// Features data for different languages and devices

const featuresData = {
  en: {
    desktop: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/LargeScreens/English/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/LargeScreens/English/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/LargeScreens/English/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/LargeScreens/English/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/LargeScreens/English/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/LargeScreens/English/6.webp', animationDelay: '0.6s' }
    ],
    mobile: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/Mobile/English/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/Mobile/English/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/Mobile/English/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/Mobile/English/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/Mobile/English/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/Mobile/English/6.webp', animationDelay: '0.6s' }
    ]
  },
  fr: {
    desktop: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/LargeScreens/French/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/LargeScreens/French/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/LargeScreens/French/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/LargeScreens/French/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/LargeScreens/French/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/LargeScreens/French/6.webp', animationDelay: '0.6s' }
    ],
    mobile: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/Mobile/French/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/Mobile/French/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/Mobile/French/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/Mobile/French/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/Mobile/French/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/Mobile/French/6.webp', animationDelay: '0.6s' }
    ]
  },
  kiny: {
    desktop: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/LargeScreens/Kinyarwanda/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/LargeScreens/Kinyarwanda/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/LargeScreens/Kinyarwanda/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/LargeScreens/Kinyarwanda/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/LargeScreens/Kinyarwanda/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/LargeScreens/Kinyarwanda/6.webp', animationDelay: '0.6s' }
    ],
    mobile: [
      { key: 'flexibleLearning', image: '/images/HowItWorks/Mobile/Kinyarwanda/1.webp', animationDelay: '0s' },
      { key: 'progressTracking', image: '/images/HowItWorks/Mobile/Kinyarwanda/2.webp', animationDelay: '0.2s' },
      { key: 'courses',          image: '/images/HowItWorks/Mobile/Kinyarwanda/3.webp', animationDelay: '0.3s' },
      { key: 'quizes',           image: '/images/HowItWorks/Mobile/Kinyarwanda/4.webp', animationDelay: '0.4s' },
      { key: 'multipleLanguages',image: '/images/HowItWorks/Mobile/Kinyarwanda/5.webp', animationDelay: '0.5s' },
      { key: '24/7Support',      image: '/images/HowItWorks/Mobile/Kinyarwanda/6.webp', animationDelay: '0.6s' }
    ]
  }
};

export default featuresData; 